import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const acknowledgeHealthInsurance = (axios: IAxiosInstance) => {
  return async () => {
    const response = await axios.noRetry.post(
      "/api/employees/acknowledge-health-insurance"
    );

    return response; // returns 204 no data
  };
};
